
import * as angular from "angular";
import * as moment from "moment";
import { VeriDate } from "@services/veriDate.service";
import "./ganttChart.scss";

export interface IGanttEventIcon {
    labelClass?: string;
    labelContent?: string;
}

export interface IGanttEvent {
    startUtc: moment.Moment;
    endUtc?: moment.Moment;

    startPercentage?: number;
    widthPercentage?: number;

    icon?: IGanttEventIcon;
    className?: string;

    highlighted?: boolean;  

    data?: any;
}

export interface IGanttSeries {
    title: string;
    className?: string;
    events: IGanttEvent[];
    isIconSeries?: boolean;
}

//export interface ITimeSeriesObject {
//    boundingRect: DOMRect | ClientRect;
//}

//export class TimeSeriesService {
//    createTimeMapping($element: HTMLElement): ITimeSeriesObject {

//        var timeSeriesObject: ITimeSeriesObject = {
//            boundingRect: $element.getBoundingClientRect()
//        };

//        return timeSeriesObject;
//    }
//}

class DriverActivityGanttController implements angular.IComponentController {

    ganttSeries: IGanttSeries[] = []; // rename to display series?
    timeSeries: { startPercentage: number, time: moment.Moment, hide?: boolean }[] = [];

    minTime: moment.Moment;
    maxTime: moment.Moment;

    showIndicator = false;
    sidePadding = 32;
    labelWidth = 100;
    elementClientX: number;
    indicatorX: number;
    indicatorTime: moment.Moment;
    minutesPerPixel: number;

    showNoDataMessage: boolean;

    onMousemove: (args: { time: moment.Moment }) => void;
    onMouseClick: (args: { time: moment.Moment }) => void;

    private throttleMouseMove: ($event: MouseEvent) => void;

    static $inject = ["$element", "veriDate", "$throttle"];

    constructor(
        private readonly $element: JQLite,
        private readonly veriDate: VeriDate,
        private readonly $throttle: any) {

        //this.debounceMouseMove = this.debounceService.debounce(($event: MouseEvent) => { this.mousemove($event, false); }, 10, true);
        this.throttleMouseMove = this.$throttle(($event: MouseEvent) => { this.mousemove($event, false); }, 10);
    }

    $onInit(): void {
        this.elementClientX = this.$element[0].getBoundingClientRect().left;
        //console.log(this.$element[0].clientLeft/*.clientLeft, this.$element[0].offsetLeft*/);
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.labelWidth = this.labelWidth || 100;

        if (onChangesObj["labelWidth"] && this.ganttSeries) {
            this.calculateMinMaxTime();
        }

        if (onChangesObj["ganttSeries"] && this.ganttSeries) {

            this.processUpdate();
        }
    }

    mousemove($event: MouseEvent, requiresDebounce = true) {

        if (requiresDebounce) {
            this.throttleMouseMove($event);
            return;
        }

        var newTime = this.getEventIndicatorTime($event);
        if (!newTime) {
            return;
        }

        this.indicatorTime = newTime;

        this.showIndicator =
            this.indicatorTime.isSameOrAfter(this.minTime /*this.timeSeries[0].time*/) &&
            this.indicatorTime.isSameOrBefore(this.maxTime/*this.timeSeries[this.timeSeries.length - 1].time*/);

        if (this.onMousemove) {
            this.onMousemove({ time: this.indicatorTime });
        }
    }

    mouseClick($event: MouseEvent) {
        var clickTime = this.getEventIndicatorTime($event);

        this.indicatorTime = clickTime || this.indicatorTime;

        if (this.onMouseClick) {
            this.onMouseClick({ time: this.indicatorTime });
        }
    }

    mouseleave($event: MouseEvent) {
        this.showIndicator = false;
    }

    // -------------------------

    private getEventIndicatorTime($event: MouseEvent): moment.Moment {
        var roundedMouseX = Math.round($event.clientX - this.elementClientX);
        if (roundedMouseX == this.indicatorX) {
            return null;
        }

        this.indicatorX = roundedMouseX /*+ sidePadding*/;
        const timePosition = this.indicatorX - this.labelWidth - this.sidePadding;
        return this.minTime.clone().add(this.minutesPerPixel * timePosition, "m");
    }

    private reset() {
        this.timeSeries = [];
        this.minTime = null;
        this.maxTime = null;
    }

    private processUpdate() {

        this.reset();

        if (this.ganttSeries.length == 0) {
            return;
        }

        this.calculateTimeSeries();
        this.postProcessGanttEvents();
    }

    private calculateTimeSeries() {
        this.calculateMinMaxTime();

        this.timeSeries = [];
        const graphDurationMins = this.maxTime.diff(this.minTime, "m", true);

        let roundTo = 60;
        if (graphDurationMins < 60) {
            roundTo = 15;
        }
        else if (graphDurationMins < 120) {
            roundTo = 30;
        }

        const intervals = Math.floor(graphDurationMins / roundTo);
        const currentSeriesTime = this.minTime.clone();

        this.veriDate.roundDate(currentSeriesTime, roundTo, true);

        if (intervals > 2) {
            for (let i = 0; i <= intervals; i++) {
                this.timeSeries.push({ startPercentage: 0, time: currentSeriesTime.clone() });
                currentSeriesTime.add(roundTo, "m");
            }
        }

        if (this.timeSeries.length === 0) {
            this.timeSeries.push({ startPercentage: 0, time: this.minTime.clone() });
            this.timeSeries.push({ startPercentage: 0, time: this.maxTime.clone() });
        }

        // If we have lots of time series then hide them for a better view
        if (this.timeSeries.length > 7) {
            this.timeSeries.forEach((t, i) => {
                if (i % 2 != 0) {
                    t.hide = true;
                }
            });
        }
    }

    private calculateMinMaxTime() {

        for (var gi = 0; gi < this.ganttSeries.length; gi++) {
            const series = this.ganttSeries[gi];

            if (!series.events) {
                console.error("Gantt Series contains NULL events - requires an empty array");
                series.events = [];
            }

            for (var ei = 0; ei < series.events.length; ei++) {
                const event = series.events[ei];
                if (event.startUtc) {
                    if (!this.minTime || event.startUtc.isBefore(this.minTime)) {
                        this.minTime = event.startUtc;
                    }
                }

                if (event.endUtc) {
                    if (!this.maxTime || event.endUtc.isAfter(this.maxTime)) {
                        this.maxTime = event.endUtc;
                    }
                }
            }
        }

        this.showNoDataMessage = false;

        if (!this.minTime || !this.maxTime) {
            //console.error("GanttChat: No min or max time, setting defaults");
            this.minTime = moment();
            this.maxTime = moment().add(1, "h");
            this.showNoDataMessage = true;
        }
        else {
            //console.log(this.minTime.format(), this.maxTime.format());
        }

        var adjustedWidth = this.$element[0].offsetWidth - this.labelWidth - (this.sidePadding * 2);
        this.minutesPerPixel = this.maxTime.diff(this.minTime, "m") / adjustedWidth;
        //console.log("minutesPerPixel", this.$element[0].offsetWidth, this.minutesPerPixel, this.maxTime.diff(this.minTime, "m"));
        //console.log("adustedwidth", adjustedWidth, this.labelWidth);
    }

    private postProcessGanttEvents() {
        const graphDurationSecs = this.maxTime.diff(this.minTime, "s");

        const percentPerSec = 100 / graphDurationSecs;

        for (var gi = 0; gi < this.ganttSeries.length; gi++) {
            const series = this.ganttSeries[gi];

            for (var ei = 0; ei < series.events.length; ei++) {
                const event = series.events[ei];

                if (!event.endUtc) {
                    event.endUtc = this.maxTime;
                }

                if (event.startUtc && event.endUtc) {
                    event.startPercentage = event.startUtc.diff(this.minTime, "s") * percentPerSec;
                    event.widthPercentage = event.endUtc.diff(event.startUtc, "s") * percentPerSec;
                }
            }
        }

        this.timeSeries.forEach(series => {
            series.startPercentage = series.time.diff(this.minTime, "s") * percentPerSec;
        });
    }
}

export class DriverActivityGanttComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            labelWidth: "<",
            ganttSeries: "<",
            onMousemove: "&",
            onMouseClick: "&"
        };

        this.controller = DriverActivityGanttController;
        this.template = require("./ganttChart.html");
    }
}
